import React from 'react'
import {AiOutlineSecurityScan} from 'react-icons/ai'
function security() {
  return (
    <div>  <div className='timeline-container1'>
        
    <h1 className='exper1'>Security Things..</h1>
    
        <li>Secure Coding Practices</li>
        <li>Penetration Testing👾</li>
        <li>Encryption👾</li>
        <li>Vulnerability Assessment</li>
        <li>Network Security👾</li>
        
</div>
</div>
  )
}

export default security